import {KTSVG} from '../../../_metronic/helpers'
import React, {FC, forwardRef, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useWindowWidth} from '@react-hook/window-size/throttled'
import useNotificationSound from '../../helpers/notifications/useNotificationSound'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)

type Props = {
  show: boolean
  handleClose: () => void
  mpesacallback: any
 
}

interface PaymentData {
  Amount: number;
  MpesaReceiptNumber: string;
  TransactionDate: number;
  PhoneNumber: string;
}


const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME

export const MpesastkCallback: FC<Props> = forwardRef((props, ref) => {
 
  const truncate = require('truncate')
  const onlyWidth = useWindowWidth()
  const { playSound } = useNotificationSound({ audioFileUrl: '/media/sound/notification.mp3' });
 
  
  

  useEffect(() => {

     if(props.show)
     {
      playSound();
     }
    const timeoutId = setTimeout(() => {
     
      props.handleClose();
    }, 10000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [props.show]);


 

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>STK Callback
          <span className='h-10px border-gray-200 border-start mx-2'></span>

           <span className='text-muted fw-bold fs-6'>{props.mpesacallback.merchantrequestid}</span>
          
          </h3>
          

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
        <div className='fv-row mb-7'>
              <div className='card bg-light'>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='required card-label fw-bolder fs-5 mb-1'>Transaction Summary</span>
                    <span className='text-muted mt-1 fw-bold fs-7'>
                    Checkout Requestid: {props.mpesacallback.checkoutrequestid}
                    </span>
                  </h3>
                  
                </div>
                {/* end::Header */}
                {/* begin::Body */}
                <div className='card-body py-3'>
                  <>
                  <span>
                 {props.mpesacallback.resultdescription}
                 </span>

                 {props.mpesacallback.details  && props.mpesacallback.details.length > 0 ? 
                 <div>
                 
                 <span className='mt-2'>

                 You have received a payment of <span className='fw-bolder'>{addCommas((props.mpesacallback.details.find((item: any) => item.Name === "Amount")?.Value).toFixed(2)) ?? 0}  {CURRENCY_APP} </span>through MPESA, with receipt number <span className='fw-bolder'>{(props.mpesacallback.details.find((item:any) => item.Name === "MpesaReceiptNumber")?.Value) ?? "Not Available"}</span>. 
                 The payment was made from phone number <span className='fw-bolder'>{props.mpesacallback.details.find((item: any) => item.Name === "PhoneNumber")?.Value ?? "Not Available"}</span> on <span className='fw-bolder'>{dayjs(String((props.mpesacallback.details.find((item:any) => item.Name === "TransactionDate")?.Value)) ?? null, 'YYYYMMDDHHmmss').locale('en').format('LLLL')}</span>.

                 </span>
                 </div>
                 :

                 <></>
                 }
                  <span className='mb-2'></span>
                  </>
                </div>
                {/* begin::Body */}
              </div>
            </div>

          
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Close
          </button>
          
        </div>
      </div>
    </Modal>
  )
})
